import React from "react";

import "../styles/Footer.scss";

import BrandImage from "./BrandImage";

function Footer() {
  return (
    <div className="footerContainer">
      <div className="agencyInfo">
        <BrandImage />
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras
          facilisis eu eros eu malesuada. Integer ac mattis purus.
        </p>
        <p>2020 | All Right Reserved</p>
        <p>Website made by Hubert Kozik</p>
      </div>
      <div className="serviceInfo">
        <h4>Service</h4>
        <p>Search Engine Optimization</p>
        <p>Data Analyst & Speed Optimization</p>
        <p>Social Media Advertising</p>
        <p>Media Promotion</p>
      </div>
      <div className="officeInfo">
        <h4>Our Office</h4>
        <p>
          Street 25/15a <br />
          54-334 City
        </p>
        <p>+48 123 456 789</p>
        <p>agency@mail.com</p>
      </div>
    </div>
  );
}

export default Footer;
